export default "__VITE_ASSET__CqApXUF___"